import { InputHTMLAttributes } from 'react';
import './customRadioInput.css';

export const RadioInput = (props: InputHTMLAttributes<HTMLInputElement>) => {
  return <input {...props} type="radio" className={`customRadioInput ${props.className}`} />;
};
